import BisonSkulls from "../../../../src/data/articles/magic-the-colonized/bison-skulls.jpg";
import AmericanProgress from "../../../../src/data/articles/magic-the-colonized/american-progress.jpg";
import * as React from 'react';
export default {
  BisonSkulls,
  AmericanProgress,
  React
};